import React, { useState, useEffect } from "react";
import { getCompanias } from "../../../redux/compania/actions";
import {
  Alert,
  Container,
  Tooltip,
  Dropdown,
  Modal,
  Form,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Card,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarConfig";
import messages from "../../../redux/messages";
import CustomTable from "../../../components/CustomTable";

import CustomPagint from "../../../components/CustomPagint";

import {
  getCenterCostWithPagination,
  saveCenterCost,
  editCenterCost,
  deleteCenterCost,
  resetVaccines,
} from "../../../redux/centercost/actions";

const CostCenterMaintenance = (props) => {
  const schema = Yup.object().shape({
    codigo: Yup.string()
      .ensure()
      .test("codigo-format", "**Solo admite números y letras", (value) => {
        // Lógica de temporizador para la validación
        if (value === "" || !value) {
          return true; // Campo vacío, no validamos todavía
        }

        if (value.length < 1) {
          return true; // No validamos hasta que se escriban al menos 1 caracter
        }

        // Aquí puedes definir tu patrón personalizado
        const pattern = /^[a-zA-Z0-9\s]+$/;
        return pattern.test(value);
      })
      .required("**Campo requerido"),
    descripcion: Yup.string().ensure().required("**Campo requerido"),
    organizacion: Yup.string().ensure().required("**Campo requerido"),
  });

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "descripcion",
    desc: "Descripción",
  });

  //paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      Header: "Codigo",
      accessor: "codigo",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },

    {
      Header: "Organización",
      accessor: "organizacion",
      // Filter: '',
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];
  const filters = [
    { id: "codigo", desc: "Código" },
    { id: "descripcion", desc: "Descripción" },
  ];
  //Redux
  const getPaginacionCC = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCenterCostWithPagination(
        {
          offset: offs,
          limit: lim,
          tipo_Busqueda: tipoBusqueda.id,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  const dispatch = useDispatch();

  const {
    loading,
    centerCost: data,
    centerCostLength: dataLenght,
    saveLoader: saveCenterCostLoader,
    centerCostError,
    formErrors,
  } = useSelector((store) => store.centerCost);
  //Organización
  const { compania, loading: companiaLoader } = useSelector(
    (store) => store.compania
  );

  const onAdd = () => {
    dispatch(resetVaccines());
    setShowModal(true);
    setEdit(false);
    // setValidated(false);
  };

  const onEdit = (item, index) => {
    dispatch(resetVaccines());
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    // setValidated(false);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPaginacionCC(oOffset, limit, oSearch);
  };
  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPaginacionCC(oOffset, limit, e.target.filter.value);
  };

  useEffect(() => {
    getPaginacionCC();
  }, []);

  useEffect(() => {
    dispatch(getCompanias(parseInt(props.match.params.type)));
  }, [props.match.params.type]);

  const onSubmit = (req) => {
    // e.preventDefault();
    // const form = e.currentTarget;
    // if (form.checkValidity() === false) {
    //   setValidated(true);
    //   return;
    // }

    // const oData = {
    //   codigo: e.target.codigo.value,
    //   descripcion: e.target.descripcion.value,
    //   organizacion: e.target.organizacion.value,
    // };

    if (edit) {
      dispatch(
        editCenterCost(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
      // setShowModal(false);
    } else {
      dispatch(
        saveCenterCost(req, parseInt(props.match.params.type), setShowModal)
      );
      // setShowModal(false);
    }
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCenterCost(id, index, parseInt(props.match.params.type)));
    }
  };

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const pages = Math.ceil(data ? dataLenght / limit : 0);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              Centro de Costo
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!centerCostError && !loading && (
            <Alert variant="danger" className="m-2">
              {centerCostError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 && compania.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={data.map((d) => ({
                      ...d,
                      organizacion: !!compania.find(
                        (c) => c.id === d.organizacion
                      )
                        ? compania.find((c) => c.id === d.organizacion).nombre
                        : "Sin Asignar",
                    }))}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={dataLenght}
                pages={pages}
                pagFunc={getPaginacionCC}
              />
            </>
          ) : (
            <>
              {centerCostError === "" && (
                <Alert variant="info" className="my-4">
                  Aún no hay ningun centro de costo, comience agregando alguno.
                </Alert>
              )}
            </>
          )}
        </div>
      </div>
      <Modal show={showModal} size="lg" onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            codigo: edit ? editItem.codigo : "",
            descripcion: edit ? editItem.descripcion : "",
            organizacion: edit
              ? compania.find((c) => c.nombre === editItem.organizacion)
                ? compania.find((c) => c.nombre === editItem.organizacion).id
                : ""
              : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar centro de costo" : "Crear centro de costo"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formErrors && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formErrors}
                  </Alert>
                )}
                <Row>
                  <Form.Group
                    as={Col}
                    sm="12"
                    md="12"
                    lg="4"
                    controlId="codigo"
                  >
                    <Form.Label className="ml-2">Código</Form.Label>
                    <Form.Control
                      id="codigo"
                      name="codigo"
                      isInvalid={touched.codigo && errors.codigo}
                      isValid={touched.codigo && !errors.codigo}
                      onBlur={handleBlur("codigo")}
                      onChange={handleChange}
                      value={values.codigo}
                      className="rounded-pill"
                      type="text"
                      placeholder="Código"
                    ></Form.Control>
                    {touched.codigo && errors.codigo && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.codigo}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números
                    </Form.Control.Feedback> */}
                  </Form.Group>
                  <Form.Group as={Col} controlId="descripcion">
                    <Form.Label className="ml-2">Descripción</Form.Label>
                    <Form.Control
                      id="descripcion"
                      name="descripcion"
                      isInvalid={touched.descripcion && errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      value={values.descripcion}
                      className="rounded-pill"
                      type="text"
                      placeholder="Descripción"
                      // pattern="[a-zA-Z][a-zA-Z\s]*[A-Za-z0-9]+"
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.descripcion}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="organizacion">
                    <Row className="align-items-end">
                      <Col sm={companiaLoader ? "10" : "12"}>
                        <Form.Label className="ml-2">Organización</Form.Label>
                        <Form.Control
                          id="organizacion"
                          name="organizacion"
                          isInvalid={
                            touched.organizacion && errors.organizacion
                          }
                          isValid={touched.organizacion && !errors.organizacion}
                          onBlur={handleBlur("organizacion")}
                          onChange={handleChange}
                          value={values.organizacion}
                          className="rounded-pill"
                          as="select"
                          disabled={companiaLoader || compania.length === 0}
                        >
                          <option key={0} value="" disabled selected></option>
                          {compania.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </Form.Control>
                        {touched.organizacion && errors.organizacion && (
                          // <div>
                          <small className="mx-2 text-danger">
                            {errors.organizacion}
                          </small>
                          // </div>
                        )}
                        {/* <Form.Control.Feedback type="invalid">
                          **Campo requerido
                        </Form.Control.Feedback> */}
                      </Col>
                      {companiaLoader && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveCenterCostLoader}
                  variant="primary"
                  type="submit"
                >
                  {saveCenterCostLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default CostCenterMaintenance;
